import { SxProps } from "@mui/material";

export const wrapperMain: SxProps = {
  "&>div:first-of-type": {
    width: "478px",
    maxWidth: "100%",
    margin: "0 auto",
    minHeight: "550px",
  },
};
export const wrapperHeader: SxProps = {
  maxWidth: "100%",
  display: "flex",
  justifyContent: "center",
  "& h5": {
    fontWeight: "700",
  },
  "& button": {
    position: "absolute",
    color: "#ffffff",
    top: "28px",
    left: "13px",
  },
};
export const wrapperSearch: SxProps = {
  display: "flex",
  "& .MuiFormControl-root": {
    width: "calc(100% - 150px)",
  },
  "& button": {
    width: "150px",
    height: "44px",
    borderRadius: "10px",
    marginLeft: "5px",
    color: "#ffffff",
  },
};
export const wrapperNoData: SxProps = {
  textAlign: "center",
  marginTop: "150px",
  fontWeight: "700",
};
export const wrapperInfo: SxProps = {
  justifyContent: "space-between",
};

export const wrapperItem: SxProps = {
  justifyContent: "space-between",
  width: "49%",
  "& p": {
    fontSize: "1rem",
  },
  "& h6": {
    fontWeight: "700",
    fontSize: "1.4rem",
  },
  "& h5": {
    fontWeight: "700",
    fontSize: "24px",
  },
};

export const wrapperId: SxProps = {
  display: "flex",
  fontSize: "1.2rem",
  cursor: "pointer",
  "& span:first-of-type": {
    marginRight: "10px",
    color: "#FF9800",
    fontWeight: "700",
  },
};
